import React, { useEffect, useRef, useState } from "react";
import { showAlert } from "../../../generalUtils";
import { MSG_AVAILABILITY_ERROR } from "./useFaceClaim";
import "./HeldFaceOverlay.css";

export const MSG_SELECTION_TAKEN = "הראש שבחרתם נתפס על ידי אורח אחר. נא לבחור ראש אחר";
export const MSG_CHECKING = "בודקים אילו ראשים פנויים...";

// A selected head that another guest holds can never stay selected: drop it, say why (toast + a persistent
// line), and leave NEXT disabled by the normal selection-count rule. Returns the persistent notice text.
export const useHeldSelectionGuard = ({ selectedImages, setSelectedImages, claim, adminPreview }) => {
  const [notice, setNotice] = useState("");
  const selectedRef = useRef(selectedImages);
  selectedRef.current = selectedImages;
  const claimRef = useRef(claim);
  claimRef.current = claim;
  useEffect(() => {
    if (adminPreview) return;
    const taken = selectedRef.current.filter((path) => claimRef.current.isBlockedByOther(path));
    if (!taken.length) return;
    setSelectedImages((current) => current.filter((path) => !claimRef.current.isBlockedByOther(path)));
    setNotice(MSG_SELECTION_TAKEN);
    showAlert("err", MSG_SELECTION_TAKEN, 5000);
    // keyed on the blocked set (and the selection): both can introduce a conflict
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [claim.blockedSignature, selectedImages, adminPreview]);
  // A fresh selection clears the explanation.
  useEffect(() => {
    if (selectedImages.length) setNotice("");
  }, [selectedImages]);
  return notice;
};

// Never present "unknown" as "free": while the first read is pending, or after a failed read, say so.
const HeldGalleryStatus = ({ claim, notice, adminPreview }) => {
  if (adminPreview) return null;
  if (claim.availability === "error") {
    return (
      <div className="held-status-notice held-status-notice--warn rtl" role="alert" data-testid="held-status-error">
        {MSG_AVAILABILITY_ERROR}
      </div>
    );
  }
  if (notice) {
    return (
      <div className="held-status-notice held-status-notice--warn rtl" role="alert" data-testid="held-status-taken">
        {notice}
      </div>
    );
  }
  if (claim.availability === "loading") {
    return (
      <div className="held-status-notice held-status-notice--info rtl" role="status" data-testid="held-status-loading">
        {MSG_CHECKING}
      </div>
    );
  }
  return null;
};

export default HeldGalleryStatus;
